import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { clearActiveStore, getActiveStoreId, setActiveStore } from "@/lib/activeStore";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("s24_token");
    if (!token) { setUser(false); setReady(true); return; }
    api.get("/auth/me")
      .then(({ data }) => {
        if (data.role === "vendor" && !getActiveStoreId(data.id)) setActiveStore(data.id, data.store_id);
        setUser(data);
      })
      .catch(() => { localStorage.removeItem("s24_token"); clearActiveStore(); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = (token, u) => {
    localStorage.setItem("s24_token", token);
    clearActiveStore();                                   // a new session never inherits another user's store
    if (u?.store_id) setActiveStore(u.id, u.store_id);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("s24_token");
    clearActiveStore();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
